import { WORDS, WORD_IMAGES } from '../constants/wordList';

export const getRandomWordAndImage = async () => {
  try {
    // Get random word from our wordList
    const word = WORDS[Math.floor(Math.random() * WORDS.length)];
    
    // Get corresponding image
    const imageUrl = require(`../assets/images/${WORD_IMAGES[word]}`);
    
    return { word, imageUrl };
  } catch (error) {
    console.error('Error getting word and image:', error);
    // Fallback
    return {
      word: 'CLOCK',
      imageUrl: require('../assets/images/clock.jpg')
    };
  }
}; 